/**
 * @constant
 */
export const ADDED = 'notifications/ADDED'

/**
 * @constant
 */
export const DISMISSED = 'notifications/DISMISSED'

/**
 * @constant
 */
export const DISMISSED_ALL = 'notifications/DISMISSED_ALL'
